module.exports = __webpack_public_path__ + "img/Logo_iNoe_120px.852376f3.png";